<script>

import { mapGetters } from 'vuex';
import { getBanks } from '@/constants/sourcesConfiguration';
import _ from 'lodash';

export default {
  name: 'CustomerBenefits',
  computed: {
    ...mapGetters('sourceFields', ['sortedBankSources']),
    sortedCombinedBankSources() {
      // TOD YY - delete this combination once we delete the sourceFields
      const sortedBanks = this.sortedBankSources;
      const bankConfigurations = getBanks();
      return _.sortBy(_.concat(sortedBanks, bankConfigurations), b => b.sortPriority);
    },
  },
};

</script>
